import React, { useEffect, useState } from 'react';
import PostcodeSearch from './PostcodeSearch';
import { graphql } from 'gatsby';
import useScreenSize from '../hooks/useScreenSize';
const ModularPostcode = ({ data }) => {
  const [selectedAddress, setSelectedAddress] = useState(undefined);
  const [inputDisplayValue, setInputDisplayValue] = useState('');

  const screenSize = useScreenSize();

  const {
    noBottomPadding,
    noTopPadding,
    backgroundColor,
    buttonText,
    placeholder,
    hideOnMobile,
    hideOnDesktop,
    negativeBottomMargin,
  } = data;

  const showPostcode = hideOnDesktop
    ? screenSize.width >= 1200
    : hideOnMobile
      ? screenSize.width <= 1199
      : false;

  return (
    !showPostcode && (
      <div
        className={`modular-postcode-container ${backgroundColor} ${
          negativeBottomMargin && 'modular-negative-bottom-margin'
        }`}
      >
        <div
          className={`modular-global-width ${
            noBottomPadding && 'modular-padding-large-no-bottom'
          } ${noTopPadding && 'modular-padding-large-no-top'} ${
            !noBottomPadding && !noBottomPadding && 'modular-padding-large'
          }`}
        >
          <div className="PostcodeSearchPrimary">
            <PostcodeSearch
              selectedAddress={selectedAddress}
              setSelectedAddress={setSelectedAddress}
              inputDisplayValue={inputDisplayValue}
              setInputDisplayValue={setInputDisplayValue}
              placeholder={placeholder}
              textButton={buttonText}
            />
          </div>
        </div>
      </div>
    )
  );
};

export default ModularPostcode;
export const fragment = graphql`
  fragment ModularPostcode on DatoCmsPostcodeChecker {
    internal {
      type
    }
    backgroundColor
    buttonText
    noBottomPadding
    noTopPadding
    textAlign
    placeholder
    hideOnMobile
    hideOnDesktop
    negativeBottomMargin
  }
`;
